import React from 'react'
import Text from '../text/Text'
import {useTag} from '../../utils/etc'

interface IProps {
    className?: string
    textClassName?: string
    state?: boolean
    children?: any
    onClick?: () => void
}

const WizTag: React.FC<IProps> = ({className, textClassName, state = false, children, onClick}) => {
    const {renderStateColor} = useTag()

    return (
        <div className={className}>
            <Text
                onClick={onClick}
                className={`text-body3 font-bold w-min px-[7px] rounded-[5px] py-[2px] whitespace-nowrap ${renderStateColor(
                    !!state,
                )} ${textClassName}`}>
                {children}
            </Text>
        </div>
    )
}

export default WizTag
